"use client"

import FooterGroup from "@/components/footer-group"
import { ComponentConfig } from "@measured/puck"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface FooterGroupProps extends CommonStylesProps {
  copyright?: string
  office?: string
  locale?: string
  about?: string
  info?: string
  aboutLinks?: {
    title: string
    url: string
  }[]
  infoLinks?: {
    title: string
    url: string
  }[]
}

export const RenderConfig: ComponentConfig<FooterGroupProps> = {
  render: ({
    className,
    styles,
    responsiveType,
    aboutLinks = [],
    infoLinks = [],
    locale = "",
    copyright = "Bản quyền thuộc về Tamda Foods s.r.o © 2011 - 2025",
    office = "Văn phòng & chi nhánh",
    about = "Về Tamda Group",
    info = "Thông tin",
  }) => {
    const id = `footer-group-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={className} id={id}>
          <FooterGroup
            aboutLinks={aboutLinks}
            infoLinks={infoLinks}
            locale={locale}
            office={office}
            about={about}
            info={info}
          />
        </div>
      </>
    )
  },
}

export default RenderConfig
